import { 
    VEHICLETYPES_FETCHING,
    VEHICLETYPES_FAILED,
    VEHICLETYPES_SUCCESS, 
} from "../actions/types";

const initialState = {
    result: null,
    isFetching: false,
    isError: false,
  };
  
  export default function (state = initialState, action) {
    const { type, payload } = action;
    switch (type) {
      case VEHICLETYPES_FETCHING:
        return { ...state, result: null, isFetching: true, isError: false };
      case VEHICLETYPES_FAILED:
        return { ...state, result: null, isFetching: false, isError: true };
      case VEHICLETYPES_SUCCESS:
        return { ...state, result: payload, isFetching: false, isError: false };
      default:
        return state;
    }
  }